import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-pm-tubiao",
  "use": "icon-pm-tubiao-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-pm-tubiao\"><defs><style type=\"text/css\"></style></defs><path d=\"M65.511111 896.977778h773.955556V240.444444H65.511111v656.533334z m53.333333-53.333334V744.888889l183.022223-86.755556 172.444444 88.088889 225.422222-218.755555L786.133333 678.222222v165.422222H118.844444z m667.288889-549.866666v277.244444l-74.311111-129.6-247.288889 239.911111-161.777777-82.577777-183.911112 87.111111V293.777778h667.288889z\" p-id=\"15317\" /><path d=\"M302.844444 128v53.333333H904.888889v495.733334h53.333333V128zM312.888889 527.111111c47.022222 0 85.333333-38.311111 85.333333-85.333333s-38.311111-85.333333-85.333333-85.333334-85.333333 38.311111-85.333333 85.333334 38.311111 85.333333 85.333333 85.333333z m0-117.333333c17.688889 0 32 14.311111 32 32s-14.311111 32-32 32-32-14.311111-32-32 14.311111-32 32-32z\" p-id=\"15318\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/pm-tubiao.svg
// module id = kCg5
// module chunks = 157